const MetamaskWallet = ({ props }) => {
  return (
    <svg
      viewBox="0 0 50 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M46.6191 0.685547L27.8809 14.6027L31.346 6.39176L46.6191 0.685547Z"
        fill="#E2761B"
        stroke="#E2761B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.36217 0.685547L21.9497 14.7345L18.6541 6.39176L3.36217 0.685547ZM39.8782 32.9454L34.8876 40.5914L45.5656 43.5292L48.6352 33.1149L39.8782 32.9454ZM1.38477 33.1149L4.43561 43.5292L15.1136 40.5914L10.123 32.9454L1.38477 33.1149Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5107 20.0263L11.5352 24.5273L22.1378 24.9981L21.7611 13.6045L14.5107 20.0263ZM35.4711 20.0263L28.1265 13.4727L27.8817 24.9981L38.4655 24.5273L35.4711 20.0263ZM15.1133 40.5913L21.4787 37.484L15.9796 33.1902L15.1133 40.5913ZM28.5031 37.484L34.8873 40.5913L34.0022 33.1902L28.5031 37.484Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.8873 40.5912L28.5031 37.4839L29.0116 41.6458L28.9551 43.3973L34.8873 40.5912ZM15.1133 40.5912L21.0455 43.3973L21.0078 41.6458L21.4786 37.4839L15.1133 40.5912Z"
        fill="#D7C1B3"
        stroke="#D7C1B3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1389 30.4407L15.8281 28.8776L19.5758 27.1638L21.1389 30.4407ZM28.8413 30.4407L30.4044 27.1638L34.1709 28.8776L28.8413 30.4407Z"
        fill="#233447"
        stroke="#233447"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1136 40.5914L16.0176 32.9454L10.123 33.1149L15.1136 40.5914ZM33.9837 32.9454L34.8876 40.5914L39.8782 33.1149L33.9837 32.9454ZM38.4658 24.5273L27.882 24.9982L28.8613 30.4407L30.4244 27.1639L34.1908 28.8776L38.4658 24.5273ZM15.8293 28.8776L19.5957 27.1639L21.14 30.4407L22.1381 24.9982L11.5355 24.5273L15.8293 28.8776Z"
        fill="#CD6116"
        stroke="#CD6116"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5352 24.5273L15.9796 33.1902L15.8289 28.8776L11.5352 24.5273ZM34.1905 28.8776L34.0022 33.1902L38.4655 24.5273L34.1905 28.8776ZM22.1378 24.9982L21.1397 30.4407L22.3826 36.8626L22.6651 28.4068L22.1378 24.9982ZM27.8817 24.9982L27.3732 28.388L27.5992 36.8626L28.861 30.4407L27.8817 24.9982Z"
        fill="#E4751F"
        stroke="#E4751F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.8601 30.4408L27.5984 36.8626L28.5023 37.4841L34.0014 33.1903L34.1897 28.8777L28.8601 30.4408ZM15.8281 28.8777L15.9788 33.1903L21.4778 37.4841L22.3818 36.8626L21.1389 30.4408L15.8281 28.8777Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.9551 43.3973L29.0116 41.6459L28.5408 41.2316H21.441L21.0078 41.6459L21.0455 43.3973L15.1133 40.5913L17.1848 42.2862L21.3845 45.2052H28.5973L32.8157 42.2862L34.8873 40.5913L28.9551 43.3973Z"
        fill="#C0AD9E"
        stroke="#C0AD9E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.5031 37.484L27.5991 36.8625H22.3826L21.4786 37.484L21.0078 41.646L21.441 41.2317H28.5408L29.0116 41.646L28.5031 37.484Z"
        fill="#161616"
        stroke="#161616"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.4101 15.5066L49.0109 7.82302L46.6192 0.685547L28.5024 14.1319L35.4704 20.0264L45.3197 22.9078L47.5043 20.3654L46.5627 19.6874L48.0693 18.3127L46.9017 17.4087L48.4082 16.2599L47.4101 15.5066ZM0.988281 7.82302L2.58903 15.5066L1.57209 16.2599L3.07868 17.4087L1.9299 18.3127L3.43649 19.6874L2.49487 20.3654L4.6606 22.9078L14.5099 20.0264L21.4779 14.1319L3.36116 0.685547L0.988281 7.82302Z"
        fill="#763D16"
        stroke="#763D16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.3207 22.9076L35.4714 20.0263L38.4657 24.5272L34.0025 33.1901L39.8782 33.1148H48.6352L45.3207 22.9076ZM14.5109 20.0263L4.6616 22.9076L1.38477 33.1148H10.123L15.9799 33.1901L11.5354 24.5272L14.5109 20.0263ZM27.8819 24.998L28.5034 14.1319L31.346 6.3916H18.6543L21.4788 14.1319L22.1381 24.998L22.3739 28.3878L22.6653 36.8624H27.5994L27.8861 28.3878L27.8819 24.998Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MetamaskWallet;
